import * as React from 'react';
import Flex from 'antd/lib/flex';
import Space from 'antd/lib/space';
import Tag from 'antd/lib/tag';
import Typography from 'antd/lib/typography';
import { IntegrationType } from '@/types';
import IntegrationIcon from '@/components/icons/IntegrationIcon';
import { antGrey, tagStyle } from '@/components/styles/globalStyles';

interface RolloutStatusCardProps {
    integrationType?: IntegrationType;
    statusText?: string;
    statusColor?: string;
    children: React.ReactNode;
}

export const RolloutStatusCard: React.FC<RolloutStatusCardProps> = ({
    integrationType,
    statusText,
    statusColor,
    children,
}) => (
    <div
        style={{
            padding: '18px',
            borderRadius: 8,
            border: `1px solid ${antGrey.grey5}`,
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            gap: 12,
            minWidth: 0,
        }}
    >
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Space align="center">
                <Typography.Text style={{ color: antGrey.grey7 }}>Rollout status</Typography.Text>
                {statusText && (
                    <Tag style={tagStyle} color={statusColor}>
                        {statusText}
                    </Tag>
                )}
            </Space>
            {integrationType && <IntegrationIcon integrationId={integrationType} />}
        </div>
        {children}
    </div>
);

interface RolloutStatusMetricProps {
    percentage: number | string;
    detail?: React.ReactNode;
}

export const RolloutStatusMetric: React.FC<RolloutStatusMetricProps> = ({ percentage, detail }) => (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'stretch' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', gap: 24 }}>
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'baseline',
                    gap: 6,
                    maxWidth: 500,
                }}
            >
                <Typography.Text style={{ fontSize: 46, color: antGrey.grey8 }} ellipsis>
                    {percentage}%
                </Typography.Text>
                <Typography.Text
                    style={{
                        fontSize: 12,
                        color: antGrey.grey7,
                        textTransform: 'uppercase',
                        letterSpacing: '0.1em',
                        width: 'max-content',
                    }}
                    ellipsis
                >
                    of users
                </Typography.Text>
            </div>
            {detail}
        </div>
    </div>
);

export const RolloutStatusActions: React.FC<React.PropsWithChildren> = ({ children }) => (
    <Flex gap={8} style={{ width: '100%' }}>
        {children}
    </Flex>
);
